// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  Speedometer,
  Add,
  Link1,
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  BookSquare,
  Mobile,
  Crown,
  UserEdit,
  UserSearch,
  ChartSquare,FolderCloud 

} from 'iconsax-react';
import { isAdmin } from 'lib';

// type

// icons
const icons = {
  marketing: Mobile,
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  add: Add,
  link: Link1,
  Quick: Speedometer,
  report: BookSquare,
  dynamicReport: ChartSquare,
  fileHub:FolderCloud 
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //
export const getPages = (permissions) => {
  const isDevelopment = true;//process.env.NODE_ENV === 'development';
  const pages = {
    id: 'group-applications',
    type: 'group',
    className: 'dropdown',
    children: [
      {
        id: 'quick-hits',
        title: <FormattedMessage id="Quick Hits" defaultMessage={"Quick Hits"} />,
        type: 'collapse',
        icon: icons.Quick,
        className: 'dropdown-item',
        url: '/quick-hits',
        breadcrumbs: false,
        children: [
          {
            id: 'Current Notes',
            title: <FormattedMessage id="Current Notes" defaultMessage={"Current Notes"} />,
            type: 'item',
            url: '/quick-hits?id=notes',
            breadcrumbs: false
          },
          {
            id: 'Sensitive Issue',
            title: <FormattedMessage id="Sensitive Issue" defaultMessage={"Sensitive Issue"} />,
            type: 'item',
            url: '/quick-hits?id=issue',
            breadcrumbs: false
          },
          {
            id: 'Action Required',
            title: <FormattedMessage id="Action Required" defaultMessage={"Action Required"} />,
            type: 'item',
            url: '/quick-hits?id=action',
            breadcrumbs: false
          },
          {
            id: 'Health Check',
            title: <FormattedMessage id="Health Check" defaultMessage={"Health Check"} />,
            type: 'item',
            url: '/quick-hits?id=health',
            breadcrumbs: false
          },
          {
            id: 'Keep In View',
            title: <FormattedMessage id="Keep In View" defaultMessage={"Keep In View"} />,
            type: 'item',
            url: '/quick-hits?id=view',
            breadcrumbs: false
          },
          {
            id: 'Care Manager',
            title: <FormattedMessage id="Care Manager" defaultMessage={"Care Manager"} />,
            type: 'item',
            url: '/quick-hits?id=care',
            breadcrumbs: false
          }
        ]
      },

      {
        id: 'care-planning',
        title: <FormattedMessage id="Care Planning" defaultMessage={"Care Planning"} />,
        type: 'collapse',
        icon: icons.profile,
        className: 'dropdown-item',
        children: [
          {
            id: 'Cilent',
            title: <FormattedMessage id="Cilent" defaultMessage={"Cilent"} />,
            type: 'item',
            url: '/client',
            breadcrumbs: false
          },
          {
            id: 'Care Partners',
            title: <FormattedMessage id="Care Partners" defaultMessage={"Care Partners"} />,
            type: 'item',
            url: '/care-partner',
            breadcrumbs: false
          },
          {
            id: 'Care Management',
            title: <FormattedMessage id="Care Management" defaultMessage={"Care Management"} />,
            type: 'item',
            url: '/care-management',
            breadcrumbs: false
          },
          {
            id: 'Award Management',
            title: <FormattedMessage id="Award Management" defaultMessage={"Award Management"} />,
            type: 'item',
            url: '/award-management',
            breadcrumbs: false
          }
        ]
      },

      {
        id: 'Recruiting',
        title: <FormattedMessage id="Recruiting" defaultMessage={"Recruiting"} />,
        type: 'collapse',
        icon: icons.ecommerce,
        children: [
          {
            id: 'Applicants',
            title: <FormattedMessage id="Applicants" defaultMessage={"Applicants"} />,
            type: 'item',
            url: '/applicants',
            breadcrumbs: false
          },
          {
            id: 'Activities',
            title: <FormattedMessage id="Activities" defaultMessage={"Activities"} />,
            type: 'item',
            url: '/applicants/activity',
            breadcrumbs: false
          }
          // {
          //   id: 'Snapshot',
          //   title: <FormattedMessage id="Snapshot" defaultMessage={"Snapshot"} />,
          //   type: 'item',
          //   link: '/apps/e-commerce/product-details/:id',
          //   url: '/snapshot',
          //   breadcrumbs: false
          // },
          // {
          //   id: 'Status',
          //   title: <FormattedMessage id="Status" defaultMessage={"Status"} />,
          //   type: 'item',
          //   url: '/status',
          //   breadcrumbs: false
          // }
        ]
      },

      {
        id: 'Marketing',
        title: <FormattedMessage id="Marketing" defaultMessage={"Marketing"} />,
        type: 'collapse',
        icon: icons.marketing,
        children: [
          {
            id: 'Referral',
            title: <FormattedMessage id="Referral Partners" />,
            type: 'item',
            url: '/referral',
            breadcrumbs: false
          },
          {
            id: 'Prospect',
            title: <FormattedMessage id="Prospects" defaultMessage={"Prospects"} />,
            type: 'item',
            url: '/prospects',
            breadcrumbs: false
          },
          {
            id: 'Activities',
            title: <FormattedMessage id="Activities" defaultMessage={"Activities"} />,
            type: 'item',
            url: '/activity',
            breadcrumbs: false
          }
        ]
      },

      {
        id: 'Reporting',
        title: <FormattedMessage id="Reporting" defaultMessage={"Reporting"} />,
        type: 'collapse',
        icon: icons.report,
        children: [
          {
            id: 'Care Management',
            title: <FormattedMessage id="Care Management" defaultMessage={"Care Management"} />,
            type: 'item',
            url: '/reporting/care-management',
            breadcrumbs: false
          },
          {
            id: 'Applicants',
            title: <FormattedMessage id="Applicants" defaultMessage={"Applicants"} />,
            type: 'item',
            link: '/apps/e-commerce/product-details/:id',
            url: '/reporting/applicants',
            breadcrumbs: false
          },
          {
            id: 'Prospects',
            title: <FormattedMessage id="Prospects" defaultMessage={"Prospects"} />,
            type: 'item',
            url: '/reporting/prospects',
            breadcrumbs: false
          },
          {
            id: 'Referral Partners',
            title: <FormattedMessage id="Referral Partners" defaultMessage={"Referral Partners"} />,
            type: 'item',
            url: '/reporting/referral-partner',
            breadcrumbs: false
          }
        ]
      },
      ...(isDevelopment
        ? [
          {
            id: 'File Hub',
            title: (
              <FormattedMessage id="File Hub" defaultMessage={'File Hub'} />
            ),
            type: 'collapse',
            icon: icons.fileHub,
            url: '/file-hub',
            breadcrumbs: false,
          },
        ]
        : []),
      ...(isDevelopment
        ? [
          {
            id: 'Report Builder',
            title: (
              <FormattedMessage id="Report Builder" defaultMessage={'Report Builder'} />
            ),
            type: 'collapse',
            icon: icons.dynamicReport,
            url: '/report-builder',
            breadcrumbs: false,
          },
        ]
        : []),
      // {
      //   id: 'File Hub',
      //   title: <FormattedMessage id="File Hub" defaultMessage={"File Hub"} />,
      //   type: 'collapse',
      //   icon: icons.report,
      //   url: '/file-hub',
      //   breadcrumbs: false
      // },
      ...(isAdmin(permissions)
        ? [{
          id: 'Admin',
          title: <FormattedMessage id="Admin" />,
          type: 'collapse',
          // icon: Profile2User,
          icon: UserSearch,
          children: [
            {
              id: 'User Management',
              title: <FormattedMessage id="User Management" />,
              type: 'item',
              url: '/user-management',
              breadcrumbs: false
            },
            {
              id: 'Stage Management',
              title: <FormattedMessage id="Stage Management" />,
              type: 'item',
              url: '/stage-management',
              breadcrumbs: false
            }, {
              id: 'Vendor Management',
              title: <FormattedMessage id="Vendor Management" />,
              type: 'item',
              url: '/vendor-management',
              breadcrumbs: false
            }, {
              id: 'Award Type Management',
              title: <FormattedMessage id="Award Type Management" />,
              type: 'item',
              url: '/award-type-management',
              breadcrumbs: false
            }, {
              id: 'Activity Management',
              title: <FormattedMessage id="Activity Management" />,
              type: 'item',
              url: '/activity-management',
              breadcrumbs: false
            }, {
              id: 'Location Management',
              title: <FormattedMessage id="Location Management" />,
              type: 'item',
              url: '/location-management',
              breadcrumbs: false
            }, {
              id: 'Prospect Activity',
              title: <FormattedMessage id="Prospect Activity" />,
              type: 'item',
              url: '/prospect-activity',
              breadcrumbs: false
            }, {
              id: 'Referral Partners Type',
              title: <FormattedMessage id="Referral Partners Type" />,
              type: 'item',
              url: '/referral-partners-type',
              breadcrumbs: false
            }, {
              id: 'Referral Partners Activity',
              title: <FormattedMessage id="Referral Partners Activity" />,
              type: 'item',
              url: '/referral-partners-activity',
              breadcrumbs: false
            }, {
              id: 'Lead Source',
              title: <FormattedMessage id="Lead Source" />,
              type: 'item',
              url: '/lead-source',
              breadcrumbs: false
            }
            , {
              id: 'Applicant Source',
              title: <FormattedMessage id="Applicant Source" />,
              type: 'item',
              url: '/applicant-source',
              breadcrumbs: false
            }, {
              id: 'Stage Options',
              title: <FormattedMessage id="Stage Options" />,
              type: 'item',
              url: '/stage-options',
              breadcrumbs: false
            }, {
              id: 'Applicant Stage Options',
              title: <FormattedMessage id="Applicant Stage Options" />,
              type: 'item',
              url: '/applicant-stage',
              breadcrumbs: false
            }, {
              id: 'Lost Client Options',
              title: <FormattedMessage id="Lost Client Options" />,
              type: 'item',
              url: '/lost-client-options',
              breadcrumbs: false
            }, {
              id: 'Contact Types',
              title: <FormattedMessage id="Contact Types" />,
              type: 'item',
              url: '/contact-types',
              breadcrumbs: false
            }, {
              id: 'Contact Relationships',
              title: <FormattedMessage id="Contact Relationships" />,
              type: 'item',
              url: '/contact-relationships',
              breadcrumbs: false
            }, {
              id: 'Client Deactivation Reasons',
              title: <FormattedMessage id="Client Deactivation Reasons" />,
              type: 'item',
              url: '/client-deactivation',
              breadcrumbs: false
            }, {
              id: 'Care Partner Deactivation Reasons',
              title: <FormattedMessage id="Care Partner Deactivation Reasons" />,
              type: 'item',
              url: '/care-partner-deactivation',
              breadcrumbs: false
            },
            {
              id: 'File Uploader Sections',
              title: <FormattedMessage id="File Uploader Sections" />,
              type: 'item',
              url: '/file-hub-sections',
              breadcrumbs: false
            },
            {
              id: 'Rating Referral',
              title: <FormattedMessage id="Rating Referral" />,
              type: 'item',
              url: '/rating-referral',
              breadcrumbs: false
            },
            {
              id: 'Rating Referral Company',
              title: <FormattedMessage id="Rating Referral Company" />,
              type: 'item',
              url: '/rating-referral-company',
              breadcrumbs: false
            },
          ]
        }] : [])
    ]
  };
  return pages;
}
//export default pages;
